import { useSheetContext } from "@/context/sheet";
import { useCreateDepartment } from "@/hooks/departments";
import { CreateDepartment } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(departments)/departments/_sheet/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutateAsync } = useCreateDepartment({
    onSuccess: (department) => {
      close(() => {
        navigate({
          to: "/departments",
          params: { id: department.id.toString() },
        });
      });
    },
  });

  const create = async (department: CreateDepartment) => {
    await mutateAsync(department);
  };

  return <Form onUpsert={create} />;
}
